import InsuredName from './InsuredName';
import Address from './Address';
import PhoneNumber from './PhoneNumber';

export default class InsuredInfo {
	public name: InsuredName | null = null;
	public mailingAddress: Address | null = null;
	public phoneNumbers: PhoneNumber[] = [];
	public email: string | null = null;
	public sendPaymentReceiptToEmail: boolean | null = null;

	public constructor() {

	}
};